import React from "react";
import {Link} from "react-router-dom"
import { useCart } from "../../Context/CartContext";

const HeaderCart = () => {
  const { cartState } = useCart();

  const totalQuantity = cartState.items.reduce((total, item) => {
    return total + item.qty;
  }, 0);

  const totalPrice = cartState.items.reduce((total, item) => {
    
    const discountedPrice =
      item.price - (item.price * item.discountPercentage) / 100;
    return total + discountedPrice * item.qty;
  }, 0);

  console.log();
  return (
    <div className="dropdown dropdown-end">
      <div tabIndex={0} role="button" className="btn btn-ghost btn-circle">
        <div className="indicator">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 stroke-primary-content"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          <span className="badge badge-sm indicator-item">{totalQuantity}</span>
        </div>
      </div>
      <div
        tabIndex={0}
        className="mt-3 z-[1] card card-compact dropdown-content w-52 bg-base-100 shadow"
      >
        <div className="card-body">
          <span className="font-bold text-lg">{totalQuantity} Items</span>
          <span className="text-info">Subtotal: ${totalPrice.toFixed(2)}</span>
          <div className="card-actions">
            <Link to="/cart">
            <button className="btn btn-primary btn-block">View cart</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderCart;
